import React from 'react'
import {connect} from 'react-redux'
import LobbyModal from './LobbyModal'
import {setMatchmakingValue} from '../redux-actions/battle-actions'
import LobbyCTA from './LobbyCTA'
import {editCrewName} from '../b5-crew-management/edit-combatant-operations'

class EditCrewNameModal extends React.Component {


  constructor() {
    super();
    this.state = {
      errors: null
    };
  }

  handleSubmitForm(e) {
    if (e) {
      e.preventDefault()
    }
    const isValid =
      this.refs.input.value.length > 2 &&
      this.refs.input.value.match(/^[a-zA-Z0-9-' ]+$/);

    if (isValid) {
      this.setState(
        {
          errors: null
        },
        () => {
          //this.props.submitHandler(this.refs.input.value.trim());
          editCrewName(
            this.refs.input.value.trim()
          );

          //Just close it right away.
          setMatchmakingValue({
            isCrewNameModalOption: false
          })

        }
      );
    } else {
      this.setState({
        errors: "Invalid team name!"
      });
    }
  }

  handleCloseCrewNameModal() {
    setMatchmakingValue({
      isCrewNameModalOption: false
    })
  }

  renderErrors() {
    if (this.state.errors) {
      return (
        <div style={{ color: "red", padding: "1.3em", textAlign: "center" }}>
          {this.state.errors}
        </div>
      );
    }
    return null;
  }

  render() {
    return (
      <LobbyModal
        title="Change Crew Name"
        handleCloseCallback={this.handleCloseCrewNameModal.bind(this)}
      >
        <div>
          <div>
            <p className="Modal__paragraph">
              What is your Crew's name?
            </p>
            <form onSubmit={this.handleSubmitForm.bind(this)}>
              <input
                className="NameTextInput"
                style={{width: "95%"}}
                defaultValue={this.props.crewName}
                ref="input"
                type="text"
                autoFocus={true}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"

              />
              {this.renderErrors()}

            </form>
            <div className="Modal__btn-container" style={{paddingTop:"3em"}}>
              <LobbyCTA
              text="Change Name"
              handler={this.handleSubmitForm.bind(this)}
              isPrimary={false}
              />
            </div>
          </div>
        </div>
      </LobbyModal>
    );
  }
}

export default connect((state, props) => {
  return {
    //someProp: state.something.someProp
    crewName: state.crew.name
  }
})(EditCrewNameModal)


// WEBPACK FOOTER //
// ./src/b5-home/EditCrewNameModal.js